define('core/views/Tooltip',[
    'jquery',
    'core/views/common/HoverCard',
], function (
    $,
    HoverCard
) {
    'use strict';

    /**
     * Simple HoverCard, shown on hover, hidden when cursor moves away.
     * Can be given either a template or plainttext to show.
     */
    var Tooltip = HoverCard.extend({
        className: 'tooltip-outer message-card',

        initialize: function (options) {
            HoverCard.prototype.initialize.call(this, options);

            this.template = options.template;
            this.message = options.message;
        },

        render: function () {
            if (this.template)
                this.$el.html(this.template());
            else if (this.message)
                this.$el.html($('<div>').addClass('tooltip').text(this.message));
            else
                return;

            HoverCard.prototype.render.call(this);
        },

        // Shows the tooltip on top
        moveTo: function (target) {
            if (!target)
                return;

            var posOffset = this.constructor.POSITION_OFFSET;
            var pos = target.offset();
            var containerPos = this.getContainerPosition();
            var tooltipWidth = this.$el.width();

            this.$el.css({
                bottom: containerPos.containerOffset.height - pos.top + posOffset,
                top: 'inherit',
                left: pos.left - tooltipWidth / 2,
            });
        },
    }, {
        create: function (options) {
            return HoverCard.create(options.id, options, 'Tooltip', Tooltip);
        },

        POSITION_OFFSET: 10,
    });

    return Tooltip;
});

